
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as types from "../../../constants/ComponentConstants";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import { validatieStatussenLoaded } from "../../../actions/validatieStatusActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";
import SamenvattingForm from "./SamenvattingForm";
import Section from "../../common/Section";
import redirector from "../../../util/redirector";
import SamenvattingPageHelper from "./SamenvattingPageHelper";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import cloneDeep from 'lodash/cloneDeep';

class SamenvattingPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.filesHelper = null;
        this.state = {
            model: {
                toelatingen: []
            },
            errors: null,
            hasUnsavedChanges: false,
            fileComponents: {},
            disabled: false,
            scrollToTop: false,
            shouldScrollToFirstError: false
        };

        this.pageHelper = new SamenvattingPageHelper(this, redirector);
    }

    componentDidMount = () => {
        const params = this.props.match.params;
        const modelId = params.modelId;

        if (this.props.shouldRedirect)
            redirector.goTo(`e-loket/organisator/${modelId}/false`);
        else {
            super.componentDidMount(); // better way to handle unsaved changes
            this.pageHelper.init();
        }
    };

    componentWillUnmount() {
        this.state = {
            model: null
        };
    }
    componentDidUpdate = () => {
        super.componentDidUpdate();

        if (this.state.scrollToTop) {
            window.parent.scrollTo(0, 450);
            this.setState({
                scrollToTop: false
            });
        }
    };

    isReadyToRender = () => {
        return !!this.filesHelper;
    };

    handleOnGenereerPDF = (pdfPollingProps) => this.pageHelper.genereerPDF(pdfPollingProps);
    handleOnIsPollingDocument(componentName, maxPollTimes) {
        return this.filesHelper.isPollingDocument(componentName, maxPollTimes);
    }
    handleOnSetStyle = (feature, color) => this.pageHelper.setStyle(feature, color);

    render() {
        if (!this.isReadyToRender())
            return null;

        if (!this.state.fileComponents || !this.state.createdOnDatesForFiles) return null;

        const props = this.props;
        const {
            osmBaseLayerUrl
        } = props;
        const disabled = props.disabled;
        const downloadFileUrl = this.filesHelper.getFileDownloadUrl();
        const color = types.COLOR_PURPLE;

        let lussen = cloneDeep(this.state.lussen);

        if (lussen !== undefined && lussen !== null) {
            for (const [key, lus] of Object.entries(lussen)) {
                lus.geoJson.features = lus.geoJson.features.filter(x => x.geometry.type === "LineString" || x.geometry.type === "MultiLineString");
            }
        }

        return (
            <Section title={"Samenvatting van je tocht"} color={color}>
                <SamenvattingForm
                    disabled={disabled}
                    color={color}
                    documents={this.state.fileComponents}
                    isPollingDocument={this.handleOnIsPollingDocument}
                    onGeneratePDF={this.handleOnGenereerPDF}
                    stratenlijstFilesProps={this.pageHelper.getStratenlijstFilesProps()}
                    fileDownloadUrl={downloadFileUrl}
                    osmBaseLayerUrl={osmBaseLayerUrl}
                    lussen={lussen}
                    customBounds={this.state.customBounds}
                    onSetStyle={this.handleOnSetStyle}
                />
            </Section>);
    }
}

SamenvattingPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state) {
    const bewijsstukkenFileTypes = state.settings.fileTypes[types.FileComponentNames.BEWIJSSTUKKEN_TOELATING_];
    const disabled = state.settings.disabled;
    const shouldRedirect = !state.layout.topNavTabsSet;

    return {
        bewijsstukkenFileTypes: bewijsstukkenFileTypes,
        disabled: disabled,
        shouldRedirect: shouldRedirect,
        osmBaseLayerUrl: state.settings.osmBaseLayerUrl
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadToelatingenLayout, dispatch),
        validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SamenvattingPage);